export default "__VITE_ASSET__8182e9c0__"